export class CryptocurrencyAssetMeta {
  /**
   * @var {int}
   */
  id;

  /**
   * @var {string}
   */
  name;

  /**
   * @var {string}
   */
  symbol;

  /**
   * @var {string}
   */
  slug;

  /**
   * @var {float}
   */
  amountHeld;

  /**
   *
   * @var {float}
   */
  averagePurchasePrice;

  /**
   *
   * @var {float}
   */
  marketValue;

  /**
   *
   * @var {float}
   */
  valueAtMarriage;

  /**
   *
   * @var {string}
   */
  exchange;

  constructor(model = {}) {
    this.id = model.id;
    this.name = model.name;
    this.symbol = model.symbol;
    this.slug = model.slug;
    this.amountHeld = model.amountHeld;
    this.averagePurchasePrice = model.averagePurchasePrice;
    this.marketValue = model.marketValue;
    this.valueAtMarriage = model.valueAtMarriage;
    this.exchange = model.exchange;
  }

  /**
   *
   * @returns {string}
   */
  get title() {
    return this.name;
  }
}
